import React from 'react';
import 'react-quill/dist/quill.snow.css';
import AppContext from '../../../AppContext';
import { formatValidInput, getEmailFooter, replaceWithDummyData, formatDate } from '../../../helpers/FormatHelper';
import { PublicMessagesSave, PublicMessagesGet, PublicMessagesDelete } from '../../../networking/NetworkingMessages';
import { getStyle, notFilledSelectClass, regularSelectClass,regularInputClass } from '../../../styles/styles';
import AlertBox from '../../shared/AlertBox';
import CustomQuill from '../../shared/CustomQuill';
import DatePicker from '../../shared/DatePicker';
import { Breadcrumb } from 'antd';
import NewEditableGrid from '../../shared/NewEditableGrid'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
const style = getStyle();

export default class PublicMessagesScreen extends React.Component{
    static contextType = AppContext;
    state = {
        messageID: null,
        subject: '',
        message: '',
        activeFrom: '',
        expireOn: '',
        updateToken: '',
        publicMessages: [],
        columnDetail: {},
        validations         : {
            subject: true,
            activeFrom: true,
            expireOn: true,
            message: true,
        },        
        alertBoxYesNo_showConfirm: false,
        alertBoxYesNo_title: '',
        alertBoxYesNo_message: '',
        alertTitle: '',
        alertMessage: '',
        showAlert: false,
        showAlertError: false,
        alertHTML: false,
        errors: [],
        alertHTML: false,
        parameters: [],        
        step: 1,
        subTitle: 'New'
    }
    
    componentDidMount(){
        this.loadPublicMessage();
    }

    loadPublicMessage(){
        this.context.startLoading();
        PublicMessagesGet().then(
            (json) => {
                console.log("PublicMessagesGet");
                console.log(json);                
                this.setState({
                    publicMessages: json.publicMessages,
                    columnDetail: JSON.parse(json.columnDetail) })
                this.context.finishLoading();
            }
        )
    }

    closeAlert() {
        this.setState({ showAlert: false });
    }

    closeAlertError = () => {
        this.setState({ showAlertError: false });
    };
        
    validateFields = () =>{
        //Required
        let subject_validate    = true;
        let activeFrom_validate    = true;
        let expireOn_validate    = true;
        let message_validate    = true;
        let listErrors = [];
        if(this.state.subject === ''){
            subject_validate = false;
            listErrors.push('Subject is required.');
        }
        if(this.state.activeFrom === ''){
            activeFrom_validate = false;
            listErrors.push('Active From is required.');
        }
        if(this.state.expireOn === ''){
            expireOn_validate = false;
            listErrors.push('Expire On is required. ')
        }
        if(this.state.message === ''){
            message_validate = false;
            listErrors.push('Message is required.')
        }
        let valid = subject_validate && activeFrom_validate && expireOn_validate && message_validate
        //Date
        if(valid){
            if(new Date(this.state.activeFrom)>=new Date(this.state.expireOn)){
                listErrors.push('Active From is greater than Expire On')
            }
        }

        this.setState({
            validations     : { ...this.state.validations, 
                subject     : subject_validate,
                activeFrom  : activeFrom_validate,
                expireOn    : expireOn_validate,
                message     : message_validate
            }
        });
        return[valid, listErrors];
    }
    
    handleUpdateSubject(event){
        this.setState({subject: event.target.value});
        if(event.target.value!=''){this.setState({validations : { ...this.state.validations, subject: true }});}
    }

    handleUpdateMessage(message){
        this.setState({ message: message })
        if(message!=''){this.setState({validations : { ...this.state.validations, message: true }});}
    }

    handleUpdateActiveFrom(date){
        let value = date !== undefined ? formatDate(date) : '';
        this.setState({activeFrom: value});
        if(value!=''){this.setState({validations : { ...this.state.validations, activeFrom: true }});}
    }

    handleUpdateExpireOn(date){
        let value = date !== undefined ? formatDate(date) : '';
        this.setState({expireOn: value});
        if(value!=''){this.setState({validations : { ...this.state.validations, expireOn: true }});}
    }

    OnClickSavePublicMessage(event){        
        let valuesOfValidate = this.validateFields();
        if (valuesOfValidate[0] && valuesOfValidate[1].length === 0) {
            let json_PublicMessagesSave ={
                MessageID: this.state.messageID,
                Subject: this.state.subject,
                ActiveFrom: this.state.activeFrom,
                ExpireOn: this.state.expireOn,
                Message: this.state.message,
                Userid: localStorage.getItem('UserID'),
                UpdateToken: this.state.updateToken
            }
            this.context.startLoading();
            PublicMessagesSave(json_PublicMessagesSave).then((json) => {
                this.setState({ updateToken: json.newUpdateToken, messageID: json.newID,
                    subTitle: 'ID: '+json.newID}) 
                this.context.finishLoading();
                this.loadPublicMessage();
                this.setState({
                    showAlert: true,
                    alertTitle: 'Information',
                    alertMessage: 'Save Public Message.',
                    messageList: ''
                });
                this.returnToList();
            })            
        }
        else {
            this.setState({
                showAlert: true,
                alertTitle: 'Error',
                alertMessage: 'Please fill all mandatory fields:',
                messageList: valuesOfValidate[1]
            });
        }
    }
    
    OnClickClear(event){
        this.setState({
            subject: '',
            activeFrom: '',
            expireOn: '',
            message: '',
            updateToken: '',            
            validations: {
                subject     : true,
                activeFrom  : true,
                expireOn    : true,
                message     : true
            }})
    }
    
    OnClickExit(event){
        this.returnToList();
    }

    OnClickEditPublicMessages(event){
        console.log(event);
        this.setState({
            step: 2,
            subTitle: 'ID: '+event.MessageID,
            messageID: event.MessageID,
            subject: event.Subject,
            activeFrom: event.ActiveFrom,
            expireOn: event.ExpireOn,
            message: event.Message,
            updateToken: event.UpdateToken
        })
    }

    handleRowClickPublicMessages(event){
    }
    
    OnClickDeletePublicMessage(event){
        console.log(event);
        this.setState({
            messageID: event.MessageID,
            alertBoxYesNo_showConfirm: true,
            alertBoxYesNo_title: 'Alert',
            alertBoxYesNo_message: 'Are you sure you want to delete Public Message?'
        })
    }

    AlertBox_closeConfirm(event){
        this.setState({ alertBoxYesNo_showConfirm: false });
    }

    AlertBox_yesConfirm(event){
        this.context.startLoading();
        PublicMessagesDelete(this.state.messageID).then((json) => {
            this.context.finishLoading();
            this.loadPublicMessage();
            this.returnToList();
            this.setState({alertBoxYesNo_showConfirm: false,
                showAlert: true,
                alertTitle: 'Information',
                alertMessage: 'Delete Public Message.',
                messageList: ''
            })
        })
    }
    
    ValidateExists(event){
        let id = this.state.messageID;
        if(id==null){return true}
        else{return false}
    }
    
    FormatValidateLabel(value){
        if(value){return 'uk-form-label'}
        else {return 'uk-form-danger'}
    }

    handleOnClickAdd(){
        this.setState({step: 2, subTitle: 'New', messageID: null})
    }

    returnToList = () => {
        this.OnClickClear();
        this.setState({step: 1});
    }

    render() 
    {
        var breadcrumb = [];
        var screen = [];

        let styleActiveBreadcrumb = this.state.addBreadcrumb ? "breadcrumb-item": "breadcrumb-item-bold";
        
        switch(this.state.step){
            case 1:
                breadcrumb.push(<Breadcrumb.Item className="breadcrumb-item-bold">Public Messages</Breadcrumb.Item>);
                screen.push(
                    <div>
                        <div className="uk-width-1-1 uk-margin">
                            <button className="uk-button uk-button-green" type="button" onClick={this.handleOnClickAdd.bind(this)}>Add</button>
                        </div>
                        <div className="uk-width-1-1 uk-margin">
                            <NewEditableGrid
                                data={this.state.publicMessages}
                                columnDetails={this.state.columnDetail}
                                isEditable={false}
                                enableClick={true} 
                                clickFunction={this.handleRowClickPublicMessages.bind(this)}
                                useExportButton={false}
                                tableName="PublicMessages"                                    
                                useIcons={true}
                                dynamicActions={[{name: 'Edit', function: this.OnClickEditPublicMessages.bind(this), isIcon: true, icon: <EditOutlined /> },
                                    {name: 'Delete', function: this.OnClickDeletePublicMessage.bind(this), isIcon: true, icon: <DeleteOutlined /> }]}
                                />
                        </div>                        
                    </div>
                );
                break;
            case 2:
                breadcrumb.push(<Breadcrumb.Item className="breadcrumb-item-bold" onClick={this.returnToList}>Public Messages</Breadcrumb.Item>);
                breadcrumb.push(<Breadcrumb.Item className="breadcrumb-item-bold">{this.state.subTitle}</Breadcrumb.Item>);
                screen.push(
                    <div>
                        <div className="uk-width-1-2">
                            <label className="uk-form-label" style={style.boldLabel}>Subject (*)</label>
                            <input className={formatValidInput(this.state.validations.subject)} value={this.state.subject} type="text" onChange={this.handleUpdateSubject.bind(this)}/>
                        </div>

                        <div className="uk-width-1-2 uk-margin">
                            <label className="uk-form-label" style={style.boldLabel}>Active From (*)</label>
                            <DatePicker className={formatValidInput(this.state.validations.activeFrom)} useNew={true} readOnly={false} value={this.state.activeFrom} onDayChange={this.handleUpdateActiveFrom.bind(this)} />
                        </div>

                        <div className="uk-width-1-2 uk-margin">
                            <label className="uk-form-label" style={style.boldLabel}>Expire On (*)</label>
                            <DatePicker className={formatValidInput(this.state.validations.expireOn)} useNew={true} readOnly={false} value={this.state.expireOn} onDayChange={this.handleUpdateExpireOn.bind(this)} />
                        </div>

                        <div className="uk-width-1-1 uk-margin">
                            <label className={this.FormatValidateLabel(this.state.validations.message)} style={style.boldLabel}>Message (*)</label>
                            <CustomQuill placeholder={"Write text for the message."} theme="snow" value={this.state.message} onChange={this.handleUpdateMessage.bind(this)} parameters={this.state.parameters}/>
                        </div>

                        <div className="uk-width-1-1 uk-margin">
                            <button className="uk-button uk-button-green" type="button" onClick={this.OnClickExit.bind(this)}>Exit</button>
                            <button className="uk-button uk-button-green" type="button" onClick={this.OnClickSavePublicMessage.bind(this)}>Save</button>
                        </div>
                    </div>
                )
                break;
        }

        return(
            <div>
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        {breadcrumb}
                    </Breadcrumb>
                </div>
                {screen}

                <AlertBox open={this.state.showAlert} 
                    onClose={this.closeAlert.bind(this)} 
                    title={this.state.alertTitle} 
                    message={this.state.alertMessage} 
                    type="Ok" 
                    okClick={this.closeAlert.bind(this)}                 
                    messageBoldList = {this.state.messageList}
                    messageIsHTML={this.state.alertHTML}/>
                <AlertBox id="bneod-yesno-confirm" type="Yes/No" open={this.state.alertBoxYesNo_showConfirm} title={this.state.alertBoxYesNo_title}
                    message={this.state.alertBoxYesNo_message} yesClick={this.AlertBox_yesConfirm.bind(this)} noClick={this.AlertBox_closeConfirm.bind(this)} 
                    onClose={this.AlertBox_closeConfirm.bind(this)}/>
                <AlertBox open={this.state.showAlertError} onClose={this.closeAlertError} title='Error' message={this.state.alertMessage} type="Ok" okClick={this.closeAlertError} messageBoldList={this.state.errors}/>                
            </div>
        );
    }
}